import { Edit } from '@mui/icons-material';
import { Button, FormControl, Grid, IconButton, Dialog, TextField, Typography, FormLabel } from '@mui/material'
import React, { useState, useContext } from 'react'
import PropTypes from 'prop-types';
import { InfoContext } from '../../services/Context/Info/context';
import Subscription from '../../services/db/subscription';
import SelectComp from '../elements/SelectComp'

function AddSubscription({ data = {} }) {
  const [open, setOpen] = useState(false);
  const [info, setInfo] = useState(data);
  const { data: { subscriptionData }, setData } = useContext(InfoContext)
  const handleChange = async e => {
    setInfo(prev => ({ ...prev, [e.target.name]: e.target.value }))
  }
  const handleAdd = async (e) => {
    e.preventDefault()
    e.stopPropagation()
    new Subscription().addSubscription(info).then((r) => {
      if (info.id) {
        const ind = subscriptionData.findIndex(el => el.id === info.id)
        if (ind !== -1) {
          let c = subscriptionData.map(((el, _id) => (_id === ind ? info : el)))
          setData(p => ({ ...p, subscriptionData: c }))
        }
      }
      else setData(p => ({ ...p, subscriptionData: [...subscriptionData, { ...info, id: r }] }))
      setInfo({});
      setOpen(false)
    })
  }
  return (
    <>
      {!data.id ?
        <Button
          color='secondary'
          variant='contained'
          onClick={() => setOpen(true)}
        >
          Add Subscription
        </Button> :
        <IconButton onClick={() => setOpen(true)}>
          <Edit />
        </IconButton>
      }
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        sx={{ justifyContent: 'center', alignItems: 'center' }}
      >
        <Grid container maxWidth={'md'} sx={{ backgroundColor: 'white' }} spacing={2} padding={2}>
          <Grid item xs={12}>
            <Typography>Add Subscription</Typography>
          </Grid>
          <Grid item xs={12}>
            <FormControl title='Title' size='small' fullWidth>
              <FormLabel>Title</FormLabel>
              <TextField
                size='small'
                name='subscription'
                value={info?.subscription}
                fullWidth
                onChange={handleChange}
                type='text'
                placeholder='Enter Your title'
              />
            </FormControl>
          </Grid>
          <Grid item xs={12}>
            <FormControl title='Title' size='small' fullWidth>
              <FormLabel>Subscription Timeline(In Days)</FormLabel>
              <SelectComp
                value={info?.duration}
                data={[30, 60, 90, 180, 360]}
                name='duration'
                handleChange={handleChange}
                label=''
                size='small'
              />
            </FormControl>
          </Grid>
          <Grid item xs={12}>
            <FormControl title='Title' size='small' fullWidth>
              <FormLabel>Subscription Amount(In Rs)</FormLabel>
              <TextField
                size='small'
                name='amount'
                value={info?.amount}
                fullWidth
                onChange={handleChange}
                type='number'
                placeholder='Enter Your amount'
              />
            </FormControl>
          </Grid>
          <Grid item xs={12}>
            <Button variant='contained' color='primary' onClick={handleAdd}>Submit</Button>
          </Grid>
        </Grid>
      </Dialog>
    </>
  )
}

AddSubscription.propTypes = {
  data: PropTypes.shape({
  }).isRequired,
};

export default AddSubscription